import { Routes, Route, useLocation } from 'react-router-dom'
import PerguntasFrequentes from '../pages/PerguntasFrequentes'
import AtualizarEstoque from './../pages/Financeiro/AtualizarEstoque/index'
import InfoPNota from './../pages/Financeiro/InfoPNota/index'
import DashboardProdutividadeDetalhada from '../pages/Produtividade/DashboardProdutividadeDetalhada'
import EstimativaValor from '../pages/Produtividade/EstimativaValor'
import ProdutividadeDetalhada from '../pages/Produtividade/ProdutividadeDetalhada'
import AcompanhamentoPropostas from '../pages/Relatorios/AcompanhamentoPropostas'
import NovosChamados from '../pages/Relatorios/NovosChamados'
import PendenciasAtrasadas from '../pages/Relatorios/PendenciasAtrasadas'
import PendenciasAtrasadasTMK from '../pages/Relatorios/PendenciasAtrasadasTMK'
import PendenciasDoDia from '../pages/Relatorios/PendenciasDoDia'
import PendenciasDoDiaTMK from '../pages/Relatorios/PendenciasDoDiaTMK'
import PropostasDeConfeccoes from '../pages/Relatorios/PropostasDeConfeccoes'
import PropostasDeConfeccoesNaoRespondidas from '../pages/Relatorios/PropostasDeConfeccoesNaoRespondidas'
import PropostasImportantes from '../pages/Relatorios/PropostasImportantes'
import PropostasNaoEnviadas from '../pages/Relatorios/PropostasNaoEnviadas'
import PropostasPerdidas from '../pages/Relatorios/PropostasPerdidas'
import VendasPorEmpresa from '../pages/Relatorios/VendasEmpresa'
import ImagensProduto from '../pages/Site/ImagemProduto'
import Layout from '../pages/Site/Layout'
import StatusPedido from '../pages/StatusPedidos/AcompanhamentoProducao'
import CadastroOrcamento from '../pages/Vendas/CadastroOrcamento'
import { ConfirmaEstoque } from '../pages/Vendas/ConfirmaEstoque/ConfirmaEstoque'
import GerarPedido from '../pages/Vendas/Pedidos'
import Login from '../pages/Login'
import VendasCidade from '../pages/Relatorios/VendasCidade'
import VendasEstado from '../pages/Relatorios/VendasEstado'
import Consulta from '../pages/Vendas/Consulta'
import Parceiros from '../pages/Vendas/Parceiros'
import PreviewPropostaOrcamento from '../pages/Vendas/PreviewPropostaOrcamento'
import ImpressaoNota from '../pages/StatusPedidos/ImpressaoNota/index'
import UploadBoleto from '../pages/Financeiro/UploadBoleto'
import Contabilidade from '../pages/Financeiro/Contabilidade'
import DevolucaoTrocaCompra from '../pages/Devolucoes/DevolucaoTrocaCompra'
import DevolucaoTrocaProducao from '../pages/Devolucoes/DevolucaoTrocaProducao'
import AcompanhaCompras from '../pages/Financeiro/AcompanhaCompras'
import { RecebimentoMateriais } from '../pages/StatusPedidos/RecebimentoMateriais'
import SimulacaoProduto from '../pages/Relatorios/SimulacaoProduto'
import { NotFound } from '../pages/NotFound'
import { Markup } from '../pages/Relatorios/Markup'
import { ContasReceber } from '../pages/Financeiro/ContasReceber'
import CreditoPedido from '../pages/CreditoPedido'
import { MarkupGrafico } from '../pages/Relatorios/Markup/components/Graphics/MarkupGrafico'
import { ExportacaoNotas } from '../pages/ExportacaoNotas'
import { RelatorioDomenico } from '../pages/RelatorioDomenico'
import { useEffect } from 'react'
import { RelatorioNFG } from '../pages/RelatorioNFG'
import { EdicaoConfirmacaoCompra } from '../pages/EdicaoConfirmacaoCompra'
import { ResumoProducao } from '../pages/StatusPedidos/ResumoProducao'
import { AcompanhamentoTrocas } from '../pages/StatusPedidos/AcompanhamentoTrocas'
import { OrdemProducao } from '../pages/Site/OrdemProducao'
import { Expedicao } from '../pages/StatusPedidos/Expedicao'
import { ResumoGravacao } from '../pages/StatusPedidos/ResumoGravacao'
import { ConsultaEstoque } from '../pages/Vendas/ConsultaEstoque'
import { RetificacaoLayout } from '../pages/Site/RetificacaoLayout'
import { SolicitacaoLayout } from '../pages/Site/SolicitacaoLayout'
import { UploadCanhoto } from '../pages/StatusPedidos/UploadCanhoto'
import { RankingVendedores } from '../pages/Vendas/RankingVendedores'
import { SimulacaoFrete } from '../pages/Vendas/SimulacaoFrete'
import { GerarBoleto } from '../pages/Financeiro/GerarBoleto'
import { UploadImages } from '../pages/ADM/UploadImages'
import { ControleTrocas } from '../pages/Financeiro/ControleTrocas'
import { RouteVendas } from './vendas'
import { RouteStatusPedido } from './StatusPedido'
import { UploadImageProductSite } from '../pages/ADM/UploadImageProductSite'
import { RouteFinanceiro } from './financeiro'
import { ChamadosSolicitados } from '../pages/ADM/ChamadosSolicitados'
import { PagamentoManual } from '../pages/ADM/PagamentoManual'
import { RouteAdm } from './adm'
import { DescontoProduto } from '../pages/Relatorios/DescontoProduto'
import { RelatorioContabilidade } from '../pages/Relatorios/RelatorioContabilidade'
import { RetificacoesConcluidas } from '../pages/Site/RetificacoesConcluidas'
import { RouteRelatorios } from './relatorios'
import Header from '../components/Header'
import { useAuthentication } from '../contexts/AuthenticationProvider'
import { Feedback } from '../components/Feedback'
import { Teste } from '../pages/Teste'
import { NewHome } from '../pages/NewHome'
import { Propostas } from '../pages/Propostas'
import { Pedidos } from '../pages/Pedidos'
import { EmAprovacao } from '../pages/EmAprovacao'
import { ClientesImportantes } from '../pages/ClientesImportantes'
import { ValidacaoDeCaricatura } from '../pages/Site/ValidacaoDeCaricatura'
import { ValidacaoDeCaricaturaNumeroPedido } from '../pages/Site/ValidacaoDeCaricatura/[numeroPedido]'
import { ValidacaoCaricaturaProvider } from '../contexts/ValidacaoCaricaturaProvider'
import { WorkdayCalendar } from '../components/WorkdayCalendar'
import { OmniPromo } from '../pages/Omnipromo'
import { LayoutOmnipromo } from '../pages/Omnipromo/LayoutOmnipromo'
import { AnimatePresence } from 'framer-motion'
import { CadastrarPedido } from '../pages/Omnipromo/CadastrarPedido'
import { PedidosEmAnalise } from '../pages/Omnipromo/PedidosEmAnalise'
import { AcompanharPedido } from '../pages/Omnipromo/AcompanharPedido'
import { PedidosPagamentos } from '../pages/Omnipromo/PedidosPagamentos'

import { MonitoramentoDePedidosTerceirizados } from '../pages/Terceirizacao/Omnipromo/MonitoramentoDePedidosTerceirizados'
import { MeusChamados } from '../pages/MeusChamados'
import { ConsultarReferenciaLayout } from '../pages/Site/ConsultarReferenciaLayout'
import { ConsultarFornecedorLayout } from '../pages/Site/ConsultarFornecedorLayout'
import { Pattern } from '../pages/Pattern'

const titles = {
  '/adm/rotinas-frequentes': 'Rotinas Frequentes',
  '/adm/chamados-vendas': 'Chamados de Vendas',
  '/adm/historico-chamados': 'Histórico de Chamados',
}

export const AppRoutes = () => {
  const location = useLocation()
  useEffect(() => (document.title = titles[location.pathname] ?? 'Crm Innovation'), [location])

  const login = location.pathname === '/login'

  const { isAuthenticated } = useAuthentication()

  const urlsSemHeader = ['omnipromo']

  const hasTelefone = !urlsSemHeader.some((url) => location.pathname.includes(url))

  return (
    <>
      {isAuthenticated && <Header hasTelefone={hasTelefone} title={titles[location.pathname] ?? 'Crm Innovation'} />}

      {isAuthenticated && <Feedback />}
      <Routes>
        <Route path="/" element={<NewHome />} />
        <Route path="/propostas/:idVendedor" element={<Propostas />} />
        <Route path="/new-home" element={<NewHome />} />
        <Route path="imagens-produto" element={<UploadImageProductSite />} />

        <Route path="login" element={<Login />} />
        <Route path="imagens-produto" element={<ImagensProduto />} />
        <Route path="vendas-empresa" element={<VendasPorEmpresa />} />
        <Route path="novos-chamados" element={<NovosChamados />} />
        <Route path="pendencias-do-dia" element={<PendenciasDoDia />} />
        <Route path="pendencias-atrasadas" element={<PendenciasAtrasadas />} />
        <Route path="pendencias-do-dia-tmk" element={<PendenciasDoDiaTMK />} />
        <Route path="pendencias-atrasadas-tmk" element={<PendenciasAtrasadasTMK />} />
        <Route path="propostas-importantes" element={<PropostasImportantes />} />
        {/* <Route path="clientes-importantes" element={<ClientesImportantes />} /> */}
        <Route path="propostas-de-confeccoes" element={<PropostasDeConfeccoes />} />
        <Route path="propostas-de-confeccoes-nao-respondidas" element={<PropostasDeConfeccoesNaoRespondidas />} />
        <Route path="propostas-nao-enviadas" element={<PropostasNaoEnviadas />} />
        <Route path="acompanhamento-propostas" element={<AcompanhamentoPropostas />} />
        <Route path="propostas-perdidas" element={<PropostasPerdidas />} />
        <Route path="produtividade-detalhada" element={<ProdutividadeDetalhada />} />
        <Route path="dashboard-produtividade-detalhada" element={<DashboardProdutividadeDetalhada />} />
        <Route path="estimativa-valor" element={<EstimativaValor />} />
        <Route path="perguntas-frequentes" element={<PerguntasFrequentes />} />
        <Route path="atualizar-estoque" element={<AtualizarEstoque />} />
        <Route path="confirma-estoque" element={<ConfirmaEstoque />} />
        <Route path="pedidos" element={<GerarPedido />} />
        <Route path="status-pedido" element={<StatusPedido />} />
        <Route path="devolucao-troca-compra" element={<DevolucaoTrocaCompra />} />
        <Route path="devolucao-troca-producao" element={<DevolucaoTrocaProducao />} />
        {/* <Route
          path="orcamento"
          element={
            <OrcamentoPedidoProvider>
              <OrcamentoPedido />
            </OrcamentoPedidoProvider>
          }
        /> */}
        <Route path="orcamento" element={<CadastroOrcamento />} />
        <Route path="layout" element={<Layout />} />
        <Route path="vendas-cidade" element={<VendasCidade />} />
        <Route path="vendas-estado" element={<VendasEstado />} />
        <Route path="consulta" element={<Consulta />} />
        <Route path="clientes" element={<Parceiros />} />
        <Route path="tela-info-p-nota" element={<InfoPNota />} />
        <Route path="impressao-nota" element={<ImpressaoNota />} />
        <Route path="preview-proposta-orcamento" element={<PreviewPropostaOrcamento />} />
        <Route path="upload-boleto" element={<UploadBoleto />} />
        <Route path="contabilidade" element={<Contabilidade />} />
        <Route path="acompanhamento-compras" element={<AcompanhaCompras />} />
        <Route path="recebimento-materiais" element={<RecebimentoMateriais />} />
        <Route path="/simulacao-produto" element={<SimulacaoProduto />} />
        <Route
          path="/teste"
          element={
            <div>
              <WorkdayCalendar />
            </div>
          }
        />
        <Route path="/alterar-pedido" element={<EdicaoConfirmacaoCompra />} />
        <Route path="/markup" element={<Markup />} />
        <Route path="/markup/grafico" element={<MarkupGrafico />} />
        <Route path="/contas-receber" element={<ContasReceber />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/credito-pedido" element={<CreditoPedido />} />
        <Route path="exportacao-de-notas" element={<ExportacaoNotas />} />
        <Route path="/relatorio-domenico" element={<RelatorioDomenico />} />
        <Route path="/relatorio-nfg" element={<RelatorioNFG />} />
        <Route path="/resumo-producao" element={<ResumoProducao />} />
        <Route path="/simulacao-frete" element={<SimulacaoFrete />} />
        <Route path="/acompanhamento-trocas" element={<AcompanhamentoTrocas />} />
        <Route path="/ordem-producao" element={<OrdemProducao />} />
        <Route path="/expedicao" element={<Expedicao />} />
        <Route path="/resumo-gravacao" element={<ResumoGravacao />} />
        <Route path="/consulta-estoque" element={<ConsultaEstoque />} />
        <Route path="/retificacao-layout" element={<RetificacaoLayout />} />
        <Route path="/solicitacao-layout" element={<SolicitacaoLayout />} />
        <Route path="/upload-canhoto" element={<UploadCanhoto />} />
        <Route path="/ranking-vendas" element={<RankingVendedores />} />
        <Route path="/gerar-boleto" element={<GerarBoleto />} />
        <Route path="/upload-arquivos" element={<UploadImages />} />
        <Route path="/controle-trocas" element={<ControleTrocas />} />
        <Route path="/upload-image-site" element={<UploadImageProductSite />} />
        <Route path="/chamados-solicitados" element={<ChamadosSolicitados />} />

        <Route path="/vendas/*" element={<RouteVendas />} />
        <Route path="/relatorios/*" element={<RouteRelatorios />} />
        <Route path="/status-pedido/*" element={<RouteStatusPedido />} />
        <Route path="/financeiro/*" element={<RouteFinanceiro />} />
        <Route path="/omnipromo/*" element={<LayoutOmnipromo />}>
          <Route index element={<OmniPromo />} />
          <Route
            path="cadastrar-pedido"
            element={
              <AnimatePresence>
                <CadastrarPedido />
              </AnimatePresence>
            }
          />

          <Route
            path="pedidos-em-analise"
            element={
              <AnimatePresence>
                <PedidosEmAnalise />
              </AnimatePresence>
            }
          />

          <Route
            path="pedidos-aprovados"
            element={
              <AnimatePresence>
                <AcompanharPedido />
              </AnimatePresence>
            }
          />
          <Route
            path="pedidos-pagamentos"
            element={
              <AnimatePresence>
                <PedidosPagamentos />
              </AnimatePresence>
            }
          />
        </Route>

        <Route path="/adm/*" element={<RouteAdm />} />
        <Route path="/pagamento-manual" element={<PagamentoManual />} />
        <Route path="/relatorio-desconto-produto" element={<DescontoProduto />} />
        <Route path="/relatorio-contabilidade" element={<RelatorioContabilidade />} />
        <Route path="/retificacoes-concluidas" element={<RetificacoesConcluidas />} />
        <Route path="/teste" element={<Teste />} />
        <Route path="/pedidos-vendedor/:idVendedor" element={<Pedidos />} />
        <Route path="/pedidos-aprovacao-vendedor/:idVendedor" element={<EmAprovacao />} />
        <Route path="/clientes-importantes/:idVendedor" element={<ClientesImportantes />} />
        <Route
          path="/arte-final/validacao-de-caricatura"
          element={
            <ValidacaoCaricaturaProvider>
              <ValidacaoDeCaricatura />
            </ValidacaoCaricaturaProvider>
          }
        />
        <Route path="/arte-final/validacao-de-caricatura/:numeroPedido" element={<ValidacaoDeCaricaturaNumeroPedido />} />
        <Route path="/arte-final/consultar-referencia-layout" element={<ConsultarReferenciaLayout />} />
        <Route path="/arte-final/consultar-fornecedor-layout" element={<ConsultarFornecedorLayout />} />

        <Route path="/terceirizacao/monitoramento-pedidos" element={<MonitoramentoDePedidosTerceirizados />} />
        <Route path="/meus-chamados" element={<MeusChamados />} />
        <Route path="/pattern/*" element={<Pattern />} />
      </Routes>
    </>
  )
}
